import { fetchLookbookById } from '@app/services/lookbookRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { Lookbook } from '@typings';
import { AxiosError } from 'axios';

const LOOKBOOK_BY_ID_QUERY_KEY = 'lookbookById';

const mapLookbookFullResponseToLookbookFull = (response: Lookbook.DetailsResponse): Lookbook.Details => {
  return { ...response, navigationItems: response.navigationItems.map(mapLookbookNavigationItemResponseToNavigationItem) };
};

const mapLookbookNavigationItemResponseToNavigationItem = (response: Lookbook.NavigationItemResponse): Lookbook.NavigationItem => {
  if (response.type === 'page') {
    return {
      ...response,
      children: response.children?.map(mapLookbookNavigationItemResponseToNavigationItem),
      id: response.id.toString(),
      pageId: response.pageId.toString(),
      url: response.url,
    };
  }

  return {
    ...response,
    children: response.children?.map(mapLookbookNavigationItemResponseToNavigationItem),
    id: response.id.toString(),
  };
};

interface Props {
  refetchOnMount?: boolean;
  lookbookId: Nullable<string> | undefined;
}

export const useLookbookDetails = ({ lookbookId, refetchOnMount }: Props) => {
  const isEnabled = isDefined(lookbookId);

  return useQuery<Lookbook.DetailsResponse, AxiosError, Lookbook.Details>({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => fetchLookbookById(lookbookId) : skipToken,
    queryKey: [LOOKBOOK_BY_ID_QUERY_KEY, lookbookId],
    refetchOnMount,
    select: mapLookbookFullResponseToLookbookFull,
  });
};
